import { QUERY_KEYS } from "constants/query-keys";
import apiClient from "api/api-client";
import { ApiListResponse } from "types/api";
import { ClassifierType, ClassifierValue } from "types/classifier";
import { useList } from "hooks/use-list";

export const usePublicClassifierValues = (type: ClassifierType, limit = 1000) => {
  return useList<ClassifierValue>({
    keys: [QUERY_KEYS.publicClassifierValues, type],
    queryFn: async ({ offset, limit, filters }) => {
      return apiClient.get<ApiListResponse<ClassifierValue>>(`/public/classifiers/${type}`, {
        params: { offset, limit, ...filters },
      });
    },
    limit,
  });
};
